import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  colorSwatch: {
    paddingRight: '5px',
  },

  bold: {
    fontWeight: 'bold',
  },
})

export default useStyles
